export default {
  meta: {
    state: 200,
    msg: "操作成功",
  },
  data: [
    {
      path: "/",
      // name: "admin",
      component: () => import("@/Layout/Index.vue"),
      children: [
        // {
        //   path: "/", // 首页
        //   alias: "/",
        //   component: () => import("@/views/main/Index.vue"),
        //   // name: "home",
        //   meta: { name: "首页", icon: "icon-fangzi" },
        // },
        {
          path: "/policyInfo", // 
          alias: "/",
          component: () => import("@/views/policyInfo/Index.vue"),
          // name: "home",
          meta: { name: "首页", icon: "icon-zhengce" },
        },
        {
          path: "/powerinformation",
          component: () => import("@/views/powerInformation/Index.vue"),
          // name: "powerinformation",
          meta: { name: "用电信息", icon: "icon-leidian" },
          children: [
            {
              path: "jgjg",
              alias: "/powerinformation",
              component: () =>
                import("@/views/powerInformation/jian/Index.vue"),
            },
            {
              path: "zhuanquery",
              component: () =>
                import(
                  "@/views/powerInformation/components/zhuanQuery/Index.vue"
                ),
            },
            {
              path: "zhuanqueryhistory",
              component: () =>
                import(
                  "@/views/powerInformation/components/zhuanQueryHistory/Index.vue"
                ),
            },
            {
              path: "userquery",
              component: () =>
                import(
                  "@/views/powerInformation/components/userQuery/Index.vue"
                ),
            },
            // {
            //   path: "userqueryhistory",
            //   component: () =>
            //     import(
            //       "@/views/powerInformation/components/userQueryHistory/Index.vue"
            //     ),
            // },
          ],
        },
        {
          path: "/complaintSuggestion",
          component: () => import("@/views/complaintSuggestion/Index.vue"),
          meta: { name: "投诉与建议", icon: "icon-qiandai" },
          children: [
            {
              path: "/handleComplain",
              alias: "/complaintSuggestion",
              component: () =>
                import("@/views/complaintSuggestion/handleComplain/index.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "*",
      component: () => import("@/views/404.vue"),
    },
  ],
};
